<form-group
  (clearClicked)="filtersCleared.emit()"
  (typeaheadClearClicked)="typeaheadCleared.emit()"
  (formCreated)="formCreated.emit()"
  (submitClicked)="filtersApplied.emit()"
  [clear]="!isMobileView ? filters.clear : null"
  [configs]="filters.controls"
  [form]="filtersForm"
  [submit]="!isMobileView ? filters.submit : null"
  (selected)="handleTypeaheadOptionSelected($event)"
  class="ListViewForm"
  direction="filter"
>
</form-group>
